<div class="loading-region">
  <ng-content></ng-content>
  <div *ngIf="loading" class="loading-indicator" role="status">
    <span class="busy-spinner" aria-hidden="true"></span>
    <span class="visually-hidden">Loading…</span>
  </div>
</div>
